var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMessage = function SvgMessage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2C6.08174 2 2.50002 5.58172 2.50002 10C2.50002 11.3241 2.82093 12.5704 3.38834 13.668C3.49337 13.8712 3.52558 14.1042 3.4796 14.3282L2.78445 17.7156L6.17178 17.0204C6.39583 16.9744 6.62886 17.0066 6.83203 17.1117C7.92966 17.6791 9.1759 18 10.5 18C14.9183 18 18.5 14.4183 18.5 10C18.5 5.58172 14.9183 2 10.5 2ZM0.500017 10C0.500017 4.47715 4.97717 0 10.5 0C16.0229 0 20.5 4.47715 20.5 10C20.5 15.5228 16.0229 20 10.5 20C8.97733 20 7.53181 19.659 6.23782 19.0485L1.70105 19.9796C1.37178 20.0472 1.03059 19.9448 0.79291 19.7071C0.55523 19.4694 0.452859 19.1282 0.520432 18.799L1.45147 14.2622C0.841006 12.9682 0.500017 11.5227 0.500017 10Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 10C4.5 9.17157 5.17157 8.5 6 8.5H6.01C6.83843 8.5 7.51 9.17157 7.51 10V10.01C7.51 10.8384 6.83843 11.51 6.01 11.51H6C5.17157 11.51 4.5 10.8384 4.5 10.01V10Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 10C9 9.17157 9.67157 8.5 10.5 8.5H10.51C11.3384 8.5 12.01 9.17157 12.01 10V10.01C12.01 10.8384 11.3384 11.51 10.51 11.51H10.5C9.67157 11.51 9 10.8384 9 10.01V10Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 10C13.5 9.17157 14.1716 8.5 15 8.5H15.01C15.8384 8.5 16.51 9.17157 16.51 10V10.01C16.51 10.8384 15.8384 11.51 15.01 11.51H15C14.1716 11.51 13.5 10.8384 13.5 10.01V10Z",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMessage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "message.be31f195da13e03b53ccebd67f3c634d.svg";